import { render, staticRenderFns } from "./SettingsNotificationSmsDisabled.vue?vue&type=template&id=3a46dd60&"
import script from "./SettingsNotificationSmsDisabled.vue?vue&type=script&lang=ts&"
export * from "./SettingsNotificationSmsDisabled.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports